<span class="filtro-wrapper" [class.filtro-activo]="mostrarFiltro">
    <span
        class="filtro-trigger"
        (click)="toggleFiltro()"
        (keydown.enter)="toggleFiltro()"
        (keydown.space)="toggleFiltro()"
        type="button">
        <img *ngIf="!tieneValor" src="assets/images/buscar-embudo.png" alt="Filtrar"  class="filtro-embudo" />
        <img *ngIf="tieneValor" src="assets/images/buscar-embudo-filled.png" alt="Filtrar"  class="filtro-embudo"/>
    </span>
    <div
        class="filtro-popup"
        *ngIf="mostrarFiltro"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()">
        <div class="filtro-header">
            <span class="filtro-title">{{ placeholder }}</span>
            <button class="btn-cerrar" (click)="cerrarFiltro()" type="button">
                ×
            </button>
        </div>

        <div class="filtro-content">
            <ng-container [ngSwitch]="tipo">
                <!-- Input con botón de limpiar -->
                <div *ngSwitchCase="'input'" class="input-with-clear">
                    <input
                        type="text"
                        [value]="inputValue"
                        [placeholder]="placeholder"
                        class="form-control filtro-input"
                        (input)="onInputChange($event)"
                        (keydown.enter)="cerrarFiltro()"
                        autofocus />
                    <button
                        *ngIf="inputValue"
                        class="btn-clear"
                        (click)="limpiarFiltro()"
                        type="button">
                        ×
                    </button>
                </div>

                <!-- Input numérico con botón de limpiar -->
                <div *ngSwitchCase="'number'" class="input-with-clear">
                    <input
                        type="number"
                        [value]="inputValue"
                        [placeholder]="placeholder"
                        class="form-control filtro-input"
                        (input)="onInputChange($event)"
                        (keydown.enter)="cerrarFiltro()"
                        autofocus />
                    <button
                        *ngIf="inputValue"
                        class="btn-clear"
                        (click)="limpiarFiltro()"
                        type="button">
                        ×
                    </button>
                </div>

                <!-- Select simple con botón de limpiar -->
                <div *ngSwitchCase="'select'" class="select-with-clear">
                    <select
                        class="form-select filtro-select"
                        [(ngModel)]="value"
                        (ngModelChange)="onSelectChange($event)">
                        <option *ngIf="!value" [ngValue]="''" disabled hidden></option>
                        <option
                            *ngFor="let opcion of opciones"
                            [ngValue]="opcion.id.toString()">
                            {{ opcion.nombre }}
                        </option>
                    </select>
                    <button
                        *ngIf="value"
                        class="btn-clear"
                        (click)="limpiarFiltro()"
                        type="button">
                        ×
                    </button>
                </div>

                <!-- Selección múltiple con checkboxes -->
                <div *ngSwitchCase="'multiselect'" class="multiselect-container">
                    <ul class="multiselect-list">
                        <li *ngFor="let opcion of opciones" class="multiselect-item">
                            <label class="multiselect-label">
                                <input
                                    type="checkbox"
                                    [checked]="estaSeleccionado(opcion.id.toString())"
                                    (click)="toggleOpcionMulti(opcion.id.toString())"
                                    (change)="toggleOpcionMulti(opcion.id.toString())" />
                                {{ opcion.nombre }}
                            </label>
                        </li>
                    </ul>
                    <button
                        *ngIf="selectedValues.size > 0"
                        class="btn btn-secondary"
                        (click)="limpiarFiltro()"
                        type="button">
                        Limpiar
                    </button>
            </div>

                
            </ng-container>
        </div>
    </div>
</span>
